import { useState, useEffect, useRef, useMemo, forwardRef } from "react";
import axios from "axios";
import swal from "sweetalert";
import "@fortawesome/fontawesome-free/css/all.min.css";
import BASE_URL from "../../../assets/global/url";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import NoAccess from "../../../assets/img/NoAccess.png";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { useObserver } from "../../../hooks/customHook/useObserver";
import { parseNumber } from "../../../utils/numberFormatter";
import { usePostedCutoffValidation } from "../../../hooks/customHook/usePostedCutoffValidation";
import TotalCard from "./components/TotalCard";
import ProductionMaterialsCreateTable from "./components/ProductionMaterialsCreateTable";
import ProductionFinishedCreateTable from "./components/ProductionFinishedCreateTable";
import ProductionConsumableCreateTable from "./components/ProductionConsumableCreateTable";

const NewProductionCreate = ({ authrztn }) => {
  const defaultStartDate = new Date();
  const defaultEndDate = new Date(defaultStartDate);
  defaultEndDate.setDate(defaultEndDate.getDate() + 0);

  const userLoggedID = useDecodeToken();
  const { postedCutoffValidation } = usePostedCutoffValidation();
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [date, setDate] = useState(defaultEndDate);
  const { containerRef, containerItemRefs, visible } = useObserver();

  // State for the first table
  const [validated, setValidated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false); // Sync guard against fast double clicks
  const [production_id, setProduction_id] = useState("");
  const [description, setDescription] = useState("");
  const [machine, setMachine] = useState("");
  const [shift, setShift] = useState("");
  const [fetchWarehouse, setFetchWarehouse] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [selectedConsumable, setSelectedConsumable] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [averagePrice, setAveragePrice] = useState("");
  const [total, setTotal] = useState("");
  const [consumableMaxQuantity, setConsumableMaxQuantity] = useState(0);

  //States PRoduction
  const [stockConsumableProducts, setStockConsumableProducts] = useState([]);
  const [stock_raw_products, setStock_raw_products] = useState([]); // stocks management table fetch
  const [stock_finish_products, setStock_finish_products] = useState([]); // product table fetch
  const [consumableList, setConsumableList] = useState([]);

  const navigate = useNavigate();

  const [consumablesTotalWeight, setConsumablesTotalWeight] = useState(0);
  const [consumablesTotalCosting, setConsumablesTotalCosting] = useState(0);
  const [materialsTotalWeight, setMaterialsTotalWeight] = useState(0);
  const [materialsTotalCosting, setMaterialsTotalCosting] = useState(0);
  const [finishedTotalWeight, setFinishedTotalWeight] = useState(0);
  const [finishedTotalCosting, setFinishedTotalCosting] = useState(0);
  const [lastFocusedIndex, setLastFocusedIndex] = useState(null); // Last focused input field for produce
  const [lastFocusedIndexUnitPrice, setLastFocusedIndexUnitPrice] =
    useState(null); // Last focused input field for Unit Price

  const [consumables, setConsumables] = useState([
    {
      stock_id: "",
      prod_id: "",
      prod_code: "",
      prod_name: "",
      prod_uom: "",
      current_stock: "",
      prod_price: "",
      weightIn: 0,
      cost: "",
    },
  ]);

  // State for the first table
  const [raws, setRaws] = useState([
    {
      stock_id: "",
      vendor_id: "Any",
      prod_id: "",
      prod_code: "",
      prod_name: "",
      prod_uom: "",
      current_stock: "",
      prod_price: "",
      weightIn: 0,
      cost: "",
    },
  ]);

  // State for the second table
  const [finishedProductRows, setFinishedProductRows] = useState([
    {
      prod_id: "",
      prod_code: "",
      prod_name: "",
      prod_uom: "",
      produce: 0,
      current_stock: 0,
      costing: 0,
      unit_price: 0,
    },
  ]);

  const shiftWarehouseRef = useRef([]);

  // Fetch vendor with supplier code
  const fetchVendor = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/vendors/supplier-code`);

      const any = {
        label: "Any",
        value: "Any",
      };

      const options = res.data.map((item) => ({
        label: item.supplier_code,
        value: item.vendor_id,
      }));

      setVendorOptions([any, ...options]);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchLastCode = () => {
    axios
      .get(BASE_URL + "/production/getCode")
      .then((res) => {
        setProduction_id(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchWarehouse_function = () => {
    axios
      .get(BASE_URL + "/warehouse/getWarehouse")
      .then((res) => {
        setFetchWarehouse(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchStockConsumables = async (warehouse_id) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/production/consumables/summary`,
        {
          params: {
            selectedWarehouse: warehouse_id,
          },
        },
      );

      if (res.data) {
        setStockConsumableProducts(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchStockRaw = (warehouse_id) => {
    axios
      .get(BASE_URL + "/production/getRawProd", {
        params: {
          selectedWarehouse: warehouse_id,
          usage: "For Production Form", // To prevent fetching product with 0 stock
        },
      })
      .then((res) => {
        setStock_raw_products(res.data);
        console.log(
          "*****-------------------------------------------------*res.data: ",
          res.data,
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Get the raw material stock based on specified warehouse and vendor id
  const fetchRawMaterialStock = async (warehouseId, vendorId) => {
    try {
      const res = await axios.get(`${BASE_URL}/production/getRawProd`, {
        params: {
          selectedWarehouse: warehouseId,
          vendorId,
        },
      });

      return res.data;
    } catch (error) {
      console.error(error);
    }
  };

  const fetchStockFinish = () => {
    axios
      .get(BASE_URL + "/production/getFinishedProductsProduction")
      .then((res) => setStock_finish_products(res.data))
      .catch((err) => console.log(err));
  };

  const fetchConsumables = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/production/consumables/list`);

      setConsumableList(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchConsumableAmounts = async (consumableId) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/production/consumables/${consumableId}/summary`,
      );

      const { totalStock, averagePrice } = res.data;

      setQuantity(putComma(totalStock || 0));
      setAveragePrice(putComma(averagePrice || 0));
      setTotal(totalStock * averagePrice || 0);

      setConsumableMaxQuantity(totalStock);
    } catch (error) {
      console.error(error);
    }
  };

  const recalculateTotal = (quantity, averagePrice) => {
    setTotal(quantity * averagePrice);
  };

  // Put Comma to numbers
  const putComma = (num) => {
    let [integerPart, decimalPart] = String(num).split(".");

    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    return formattedValue;
  };

  // Handle Quantity and Unit Price change
  const handleAmountChange = (value, setter) => {
    let inputValue = String(value).replace(/[^0-9.]/g, "");

    const formattedValue = putComma(inputValue);

    const cleanedValue = formattedValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma

    setter(cleanedValue);
  };

  // Handle supplier code change
  const handleSupplierCodeChange = async (selectedOption, index) => {
    const { prod_id: productId, prod_name: productName } = raws[index];
    const vendorId = selectedOption.value;
    const supplierCode = selectedOption.label;

    // Get the updated stock with the current selected warehouse and vendor
    const stockRawProducts = await fetchRawMaterialStock(
      selectedWarehouse,
      vendorId,
    );

    const hasProduct = stockRawProducts.some((p) => p.product_id === productId); // Check if selected vendor has the selected product

    // Validation: prevent proceeding when the selected product does not exist for the chosen supplier
    if (!hasProduct && productId) {
      swal({
        icon: "error",
        title: "No Raw Material Found",
        text: `No ${productName} found with supplier code ${supplierCode}`,
      });
      return;
    }

    const selectedProduct = filteredRawProductOptions(index, vendorId).find(
      (product) => product.product_id === productId,
    );

    // Update vendor id, current stock, quantity and unit price for the selected row
    setRaws((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              vendor_id: vendorId,
              current_stock: selectedProduct?.totalStock || 0,
              prod_price: selectedProduct?.averagePrice || 0,
              weightIn: "",
            }
          : item,
      ),
    );
  };

  // For react select
  const onMenuOpen = () => {
    if (!shift || !selectedWarehouse) {
      swal({
        icon: "warning",
        title: "Missing Fields",
        text: "Please complete the production details above before selecting raw materials or finished products.",
      }).then(() => {
        shiftWarehouseRef.current[!shift ? 0 : 1].focus();
        shiftWarehouseRef.current[!shift ? 0 : 1].showPicker();
      });
      return;
    }
  };

  const menuIsOpen = !shift || !selectedWarehouse ? false : undefined; // For react select

  const onInputFloat = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  };

  // Add new consumable item
  const addNewItemConsumable = () => {
    setConsumables((prev) => [
      ...prev,
      {
        stock_id: "",
        prod_id: "",
        prod_code: "",
        prod_name: "",
        prod_uom: "",
        current_stock: "",
        prod_price: "",
        weightIn: 0,
        cost: "",
      },
    ]);
  };

  // Add new raw material item
  const addNewItemRaw = async () => {
    setRaws((prev) => [
      ...prev,
      {
        stock_id: "",
        vendor_id: "Any",
        prod_id: "",
        prod_code: "",
        prod_name: "",
        prod_uom: "",
        current_stock: "",
        prod_price: "",
        weightIn: 0,
        cost: "",
      },
    ]);
  };

  const deleteItemConsumable = (indexToDelete) => {
    setConsumables((prev) =>
      prev.filter((_, index) => index !== indexToDelete),
    );
  };

  const deleteItemRaw = (indexToDelete) => {
    setRaws((prevRaws) =>
      prevRaws.filter((_, index) => index !== indexToDelete),
    );
  };

  // delete row for finish product
  const deleteFinishedProduct = (indexToDelete) => {
    setFinishedProductRows((prevRows) => {
      // Don't delete if it's the only row
      if (prevRows.length === 1) {
        return prevRows;
      }
      return prevRows.filter((_, index) => index !== indexToDelete);
    });
  };

  const addNewItemFinishProduct = () => {
    setFinishedProductRows((prev) => [
      ...prev,
      {
        prod_id: "",
        prod_code: "",
        prod_name: "",
        prod_uom: "",
        produce: 0,
        current_stock: 0,
        costing: 0,
        unit_price: 0,
      },
    ]);
  };

  const filteredConsumableOptions = (index) => {
    const prodId = consumables
      .filter((_, i) => i !== index)
      .map((item) => item.prod_id);

    return stockConsumableProducts.filter(
      (item) => !prodId.includes(item.product_id),
    );
  };

  // Get all products that are not selected yet
  const getAvailableProducts = (index, vendorId, isVendorAny) => {
    // All raw material ids except the one at the current index
    const prodId = raws
      .filter((_, i) => i !== index)
      .map((item) => item.prod_id);

    const availableProducts = stock_raw_products.filter((item) => {
      const notSelected = !prodId.includes(item.product_id); // Checks whether the product is not currently selected

      return isVendorAny
        ? notSelected // Include all unselected products, no vendor filter (Any)
        : notSelected && item.vendor_id === vendorId; // Include unselected products for the selected vendor
    });

    return availableProducts;
  };

  // prettier-ignore
  // For raw material average price computation
  const getAveragePrice = (existingProduct, newProduct) => {
    const existingProductTotalPrice = existingProduct.totalStock * existingProduct.averagePrice;
    const newProductTotalPrice = newProduct.totalStock * newProduct.averagePrice;
    const totalStock = existingProduct.totalStock + newProduct.totalStock;
    const averagePrice = totalStock ? (existingProductTotalPrice + newProductTotalPrice) / totalStock : 0;

    return averagePrice;
  };

  // Group products for vendor "Any" supplier code option
  const groupProducts = (availableProducts) => {
    const products = availableProducts.reduce((acc, value) => {
      const productId = value.product_id;

      if (!acc.has(productId)) {
        acc.set(productId, { ...value }); // Clone object to avoid mutating original state object
      } else {
        const product = acc.get(productId);
        const newAverage = getAveragePrice(product, value);
        product.totalStock += value.totalStock;
        product.averagePrice = newAverage;
      }

      return acc;
    }, new Map());

    return Array.from(products.values());
  };

  // prettier-ignore
  // For raw materials options
  const filteredRawProductOptions = (index, vendorId) => {
    const isVendorAny = vendorId === "Any";
    const availableProducts = getAvailableProducts(index, vendorId, isVendorAny);
    const consolidatedProducts = groupProducts(availableProducts);

    return isVendorAny ? consolidatedProducts : availableProducts;
  };

  // For finished product options
  const filteredFinishedProductOptions = (index) => {
    const prodId = finishedProductRows
      .filter((_, i) => i !== index)
      .map((item) => item.prod_id);

    return stock_finish_products.filter(
      (item) => !prodId.includes(item.product_id), // flat — no item.product_list.product_id wrapper
    );
  };

  // Finished Product Unit Price
  const unitPrice =
    materialsTotalCosting && finishedTotalWeight
      ? parseFloat(
          String(materialsTotalCosting / finishedTotalWeight).replace(/,/g, ""),
        ) || 0
      : 0;

  // Handle Create Production
  const add = async (e) => {
    e.preventDefault();
    if (submittingRef.current) return;
    const form = e.currentTarget;

    const modifiedFinishedProductRows = finishedProductRows
      .filter((item) => item.prod_id)
      .map((item) => ({
        ...item,
        produce: parseNumber(item.produce),
        unit_price: parseNumber(item.unit_price),
        costing: parseNumber(item.costing),
      }));

    const formatRaws = raws
      .filter((item) => item.prod_id && parseNumber(item.weightIn) >= 0)
      .map((item) => ({
        ...item,
        weightIn: parseNumber(item.weightIn),
      }));

    const formatConsumables = consumables
      .filter((item) => item.prod_id && parseNumber(item.weightIn) > 0)
      .map((item) => ({
        ...item,
        weightIn: parseNumber(item.weightIn),
      }));

    const hasMaterials = formatRaws.length > 0;
    const hasFinishedProducts = modifiedFinishedProductRows.length > 0;

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill in the red text fields.",
      });
    } else if (date && startDate && new Date(date) < new Date(startDate)) {
      swal({
        icon: "error",
        title: "Invalid Date Range",
        text: "End date cannot be earlier than the start date.",
      });
    } else if (!hasMaterials && !hasFinishedProducts) {
      swal({
        icon: "error",
        title: "No Items Added",
        text: "Please add at least one Raw Material or Finished Product to create a production.",
      });
    } else {
      let confirmTitle = "Create this new production?";
      let confirmText = "Please review the details before proceeding.";
      let isWarning = false;

      if (hasMaterials && !hasFinishedProducts) {
        confirmTitle = "No Finished Products Selected";
        confirmText =
          "You are creating a production with ONLY Raw Materials. Are you sure you want to proceed?";
        isWarning = true;
      } else if (!hasMaterials && hasFinishedProducts) {
        confirmTitle = "No Raw Materials Selected";
        confirmText =
          "You are creating a production with ONLY Finished Products. Are you sure you want to proceed?";
        isWarning = true;
      }

      swal({
        title: confirmTitle,
        text: confirmText,
        icon: "warning",
        buttons: {
          cancel: {
            text: "Cancel",
            value: null,
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Yes, Create",
            value: true,
            visible: true,
            className: "btn-primary",
            closeModal: true,
          },
        },
        dangerMode: isWarning,
      }).then((confirmed) => {
        if (confirmed) {
          if (submittingRef.current) return;
          submittingRef.current = true;
          setIsSubmitting(true);

          axios
            .post(`${BASE_URL}/production/create_production_new`, {
              raws: formatRaws,
              finishedProductRows: modifiedFinishedProductRows,
              production_id,
              description,
              startDate,
              date, // date produce or end date
              shift,
              machine,
              selectedWarehouse,
              userLoggedID,
              consumableId: selectedConsumable,
              quantity: parseNumber(quantity),
              averagePrice: parseNumber(averagePrice),
              total: parseNumber(total),
              totalQuantity: materialsTotalWeight,
              totalProduce: finishedTotalWeight,
              consumables: formatConsumables,
            })
            .then((res) => {
              if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Production created successfully",
                  icon: "success",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                }).then(() => {
                  navigate("../inventory/productions");
                });
              } else {
                submittingRef.current = false;
                setIsSubmitting(false);
                swal({
                  title: "Something Went Wrong",
                  text: "Please contact your support immediately",
                  icon: "error",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                });
              }
            })
            .catch((error) => {
              // Keep the button locked on success (page navigates away), unlock on failure
              submittingRef.current = false;
              setIsSubmitting(false);

              if (error.response && error.response.status === 409) {
                swal({
                  title: "Oopps!",
                  text: "Action is prohibited because the date provided for the Date produce has already passed the posted cutoff.",
                  icon: "error",
                  button: true,
                });
              }
            });
        }
      });
    }
    setValidated(true);
  };

  // Transition from Material Table to Finished Table
  const scrollToSide = (productCategory) => {
    const container = containerRef.current;
    if (!container) return;

    const itemWidth = containerRef.current.getBoundingClientRect().width; // Current Width of table container

    container.scrollTo({
      ...(productCategory === "finished"
        ? { left: itemWidth }
        : { left: -itemWidth }),
      behavior: "smooth",
    });
  };

  const calculateTotal = (arr, key) => {
    return arr.reduce((acc, value) => acc + parseNumber(value[key]), 0);
  };

  // Calculate Consumable Total Weight
  const calculateConsumableTotalWeight = () => {
    setConsumablesTotalWeight(calculateTotal(consumables, "weightIn"));
  };

  // Calculate Consumable Total Costing
  const calculateConsumableTotalCosting = () => {
    setConsumablesTotalCosting(calculateTotal(consumables, "cost"));
  };

  // Calculate Materials Total Weight
  const calculateMaterialTotalWeight = () => {
    setMaterialsTotalWeight(calculateTotal(raws, "weightIn"));
  };

  // Calculate Materials Total Costing
  const calculateMaterialTotalCosting = () => {
    setMaterialsTotalCosting(calculateTotal(raws, "cost"));
  };

  // Calculate Finished Product Total Produce/Weight
  const calculateFinishedProductTotalWeight = () => {
    setFinishedTotalWeight(calculateTotal(finishedProductRows, "produce"));
  };

  // Calculate Finished Product Total Costing
  const calculateFinishedProductTotalCosting = () => {
    setFinishedTotalCosting(calculateTotal(finishedProductRows, "costing"));
  };

  // Calculate Finished Product Costing when Produce field change
  const recalculateCostingOnProduceChange = () => {
    setFinishedProductRows((prev) => {
      let changed = false;

      // Newly updated finished product
      const updated = prev.map((item, index) => {
        const produce = parseNumber(item.produce);
        const unitPrice = parseNumber(item.unit_price); // use the row's own unit_price, not the global one

        const newCosting = produce * unitPrice; // costing = produce × its own unit_price

        if (newCosting !== item.costing) {
          changed = true;
        }

        return {
          ...item,
          // unit_price: !produce ? 0 : unitPrice,
          costing: newCosting,
        };
      });

      // Only Set finished product when something actually changed
      // To avoid infinite rerenders
      return changed ? updated : prev;
    });
  };

  // Calculate Finished Product Costing when Unit price field change
  const recalculateCostingOnUnitPriceChange = () => {
    setFinishedProductRows((prev) => {
      let changed = false;

      const otherRowIndexes =
        lastFocusedIndexUnitPrice !== null
          ? prev.map((_, i) => i).filter((i) => i != lastFocusedIndexUnitPrice)
          : null;

      const totalCosting = prev.reduce((acc, value) => acc + value.costing, 0);

      const remainingCost = materialsTotalCosting - totalCosting; // Get the difference between Materials and Finished Product total costing

      const avgDistributedCost =
        otherRowIndexes?.length > 0
          ? remainingCost / otherRowIndexes?.length
          : 0; // Distribute the remaining cost evenly across all items in otherRowIndexes.

      // Newly updated finished product
      const updated = prev.map((item, index) => {
        const produce = parseNumber(item.produce);

        const unitPrice = parseNumber(item.unit_price);

        const totalCostingPerUnit = item.costing + avgDistributedCost; // Add the evenly distributed remaining cost to the item's original costing.

        const newUnitPrice = produce > 0 ? totalCostingPerUnit / produce : 0; // Get the Final new unit price per produce

        const shouldApplyUnitPrice = otherRowIndexes?.includes(index);

        const finalUnitPrice = shouldApplyUnitPrice ? newUnitPrice : unitPrice;

        if (finalUnitPrice < 0) validateUnitPrice();

        const newCosting = produce * finalUnitPrice;

        if (newCosting !== item.costing) changed = true;

        return {
          ...item,
          unit_price: finalUnitPrice,
          costing: newCosting,
        };
      });

      // Only Set finished product when something actually changed
      // To avoid infinite rerenders
      return changed ? updated : prev;
    });
  };

  // Send warning to user if Total Produce exceeds the Total Weight In
  const validateTotalProduce = () => {
    if (finishedTotalWeight > materialsTotalWeight) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("center-swal-text");
      wrapper.innerHTML = `The Total Produce cannot be greater than the total available weight <strong>(${materialsTotalWeight})</strong>, Please try again.`;
      swal({
        icon: "warning",
        title: "Weight Limit Exceeded",
        content: wrapper,
      }).then(() => {
        setLastFocusedIndex(null);
      });

      setFinishedProductRows((prev) =>
        prev.map((item, index) => {
          if (lastFocusedIndex == null) {
            return {
              ...item,
              unit_price: 0,
              produce: 0,
            };
          } else {
            return index === lastFocusedIndex
              ? {
                  ...item,
                  unit_price: 0,
                  produce: 0,
                }
              : item;
          }
        }),
      );
    }
  };

  // Send warning to user if unit price happens to be negative
  const validateUnitPrice = () => {
    swal({
      icon: "warning",
      title: "Invalid Unit Price",
      text: "The entered unit price adjustment caused one or more items to have a negative unit price. Please try again.",
    }).then(() => {
      setFinishedProductRows((prev) => {
        return prev.map((item, index) => {
          return index === lastFocusedIndexUnitPrice
            ? {
                ...item,
                unit_price: 0,
                produce: 0,
              }
            : item;
        });
      });

      setLastFocusedIndexUnitPrice(null);
    });
  };

  // Get only the produce values from finishedProductRows
  const produces = useMemo(
    () => finishedProductRows.map((item) => item.produce),
    [finishedProductRows.map((item) => item.produce).join(",")],
  );

  // Get only the unit_price values from finishedProductRows
  const unitPrices = useMemo(
    () => finishedProductRows.map((item) => item.unit_price),
    [finishedProductRows],
  );

  useEffect(() => {
    fetchVendor();
    fetchLastCode();
    fetchWarehouse_function();
    fetchConsumables();
    fetchStockFinish();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    calculateConsumableTotalWeight(); // Consumable Total Weight In
    calculateConsumableTotalCosting(); // Consumable Total Costing
  }, [consumables]);

  useEffect(() => {
    calculateMaterialTotalWeight(); // Material Total Weight In
    calculateMaterialTotalCosting(); // Material Total Costing
  }, [raws]);

  useEffect(() => {
    calculateFinishedProductTotalWeight(); // Finished Product Total Produce
    calculateFinishedProductTotalCosting(); // Finished Product Total Costing
  }, [finishedProductRows]);

  // Custom input for DatePicker to strictly enforce MM/dd/yyyy hh:mm aa format
  const CustomInput = useMemo(() => {
    const Input = forwardRef(
      (
        {
          value,
          onClick,
          onChange,
          onBlur,
          onFocus,
          onKeyDown,
          disabled,
          required,
          className,
          placeholder,
          generateYears,
          ...rest
        },
        ref,
      ) => {
        const [localValue, setLocalValue] = useState(value || "");

        // Always mirror the picker's value (calendar picks keep the input focused,
        // so gating this on focus left the old date showing)
        useEffect(() => {
          setLocalValue(value || "");
        }, [value]);

        const handleChange = (e) => {
          let raw = e?.target?.value || "";
          const isDeleting = raw.length < localValue.length;
          let cursor = e.target.selectionStart;

          let cleaned = raw.replace(/[^\d/ :aApPmM]/g, "");

          // Allow free 1-by-1 backspacing by bypassing the strict rebuild during deletion
          if (isDeleting) {
            setLocalValue(cleaned);
            e.target.value = cleaned;

            // PREVENT PREMATURE VALIDATION:
            // Only fire onChange during deletion if it's completely empty or hits a valid threshold length
            if (
              cleaned === "" ||
              cleaned.length === 10 ||
              cleaned.length >= 16
            ) {
              if (onChange) onChange(e);
            }

            setTimeout(() => {
              if (e.target) e.target.setSelectionRange(cursor, cursor);
            }, 0);
            return;
          }

          // Rescue react-datepicker's initial single-digit hour format so it pads to double-digit (hh)
          if (cleaned.includes(":")) {
            let parts = cleaned.split(":");
            let beforeColon = parts[0];
            let afterColon = parts.slice(1).join(":");

            let spaceParts = beforeColon.trim().split(" ");
            if (spaceParts.length === 2 && spaceParts[1].length === 1) {
              spaceParts[1] = "0" + spaceParts[1];
              beforeColon = spaceParts.join(" ");
              cleaned = beforeColon + ":" + afterColon;
            }
          }

          let datePart = "";
          let timePart = "";
          let letters = "";

          // Isolate date and time based on space separator to protect the time block
          const spaceIndex = cleaned.search(/\s\d/);

          if (spaceIndex !== -1) {
            datePart = cleaned.substring(0, spaceIndex).replace(/[^\d]/g, "");
            timePart = cleaned.substring(spaceIndex).replace(/[^\d]/g, "");
            letters = cleaned
              .substring(spaceIndex)
              .replace(/[^apmAPM]/g, "")
              .substring(0, 2)
              .toUpperCase();
          } else {
            let digits = cleaned.replace(/[^\d]/g, "");
            datePart = digits.substring(0, 8);
            timePart = digits.substring(8, 12);
            letters = cleaned
              .replace(/[^apmAPM]/g, "")
              .substring(0, 2)
              .toUpperCase();
          }

          let formatted = "";

          // Date Formatting: MM/dd/yyyy
          if (datePart.length > 0) formatted += datePart.substring(0, 2);
          if (datePart.length > 2) formatted += "/" + datePart.substring(2, 4);
          if (datePart.length > 4) formatted += "/" + datePart.substring(4, 8);

          // Time Formatting: hh:mm
          if (
            timePart.length > 0 ||
            (spaceIndex !== -1 && datePart.length > 0)
          ) {
            if (formatted.length > 0 && !formatted.endsWith(" "))
              formatted += " ";
            if (timePart.length > 0) formatted += timePart.substring(0, 2);
            if (timePart.length > 2)
              formatted += ":" + timePart.substring(2, 4);
          }

          // AM / PM Formatting: aa
          if (letters.length > 0) {
            if (formatted.length > 0 && !formatted.endsWith(" "))
              formatted += " ";
            formatted += letters.startsWith("A")
              ? "AM"
              : letters.startsWith("P")
                ? "PM"
                : letters;
          }

          if (cursor === raw.length) {
            cursor = formatted.length;
          }

          setLocalValue(formatted);
          e.target.value = formatted;

          // PREVENT PREMATURE VALIDATION:
          // Only trigger onChange when the string length denotes a fully typed date (10) or date+time (16+)
          if (
            formatted === "" ||
            formatted.length === 10 ||
            formatted.length >= 16
          ) {
            if (onChange) onChange(e);
          }

          setTimeout(() => {
            if (e.target) e.target.setSelectionRange(cursor, cursor);
          }, 0);
        };

        // Only push uncommitted (partially typed) text, otherwise a stale value
        // would overwrite a date just picked from the calendar
        const handleBlur = (e) => {
          if (localValue !== (value || "")) {
            e.target.value = localValue;
            if (onChange) onChange(e);
          }
          if (onBlur) onBlur(e);
        };

        const handleKeyDown = (e) => {
          if (e.key === "Enter" && localValue !== (value || "")) {
            e.target.value = localValue;
            if (onChange) onChange(e);
          }
          if (onKeyDown) onKeyDown(e);
        };

        const handleFocus = (e) => {
          if (onFocus) onFocus(e);
        };

        const inputClassName =
          `form-control p-2 w-100 ${className || ""}`.trim();

        return (
          <input
            {...rest}
            type="text"
            className={inputClassName}
            style={{ cursor: disabled ? "not-allowed" : "text" }}
            onClick={(e) => {
              if (disabled) return;
              if (onClick) onClick(e);

              let dateYear = new Date().getFullYear();
              if (value) {
                const parsed = new Date(value);
                if (!isNaN(parsed.getTime())) {
                  dateYear = parsed.getFullYear();
                }
              }

              if (generateYears && typeof generateYears === "function") {
                generateYears(dateYear);
              }
            }}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onKeyDown={handleKeyDown}
            value={localValue}
            ref={ref}
            placeholder={placeholder || "MM/dd/yyyy hh:mm aa"}
            disabled={disabled}
            required={required !== undefined ? required : true}
          />
        );
      },
    );

    Input.displayName = "CustomInput";
    return Input;
  }, []);

  // Props for Consumable Table component
  const consumableTableProps = {
    consumables,
    filteredConsumableOptions,
    stockConsumableProducts,
    setConsumables,
    shift,
    selectedWarehouse,
    shiftWarehouseRef,
    validated,
    onInputFloat,
    deleteItemConsumable,
    addNewItemConsumable,
  };

  // Props for Material Table component
  const materialsTableProps = {
    raws,
    vendor: {
      vendorOptions,
      handleSupplierCodeChange,
      fetchRawMaterialStock,
    },
    onMenuOpen,
    menuIsOpen,
    selectedWarehouse,
    stock_raw_products,
    filteredRawProductOptions,
    setRaws,
    validated,
    onInputFloat,
    finishedProductRows,
    deleteItemRaw,
    addNewItemRaw,
  };

  // Props for Finished Product Table component
  const finishedTableProps = {
    finishedProductRows,
    filteredFinishedProductOptions,
    stock_finish_products,
    setFinishedProductRows,
    shift,
    selectedWarehouse,
    shiftWarehouseRef,
    validated,
    setLastFocusedIndex,
    lastFocusedIndexUnitPrice,
    setLastFocusedIndexUnitPrice,
    deleteFinishedProduct,
    addNewItemFinishProduct,
  };

  const handleDateRangeChange = async (selectedDate, type) => {
    const isStart = type === "start";

    if (
      !isStart &&
      startDate &&
      selectedDate &&
      selectedDate < new Date(startDate)
    ) {
      swal({
        icon: "error",
        title: "Invalid Date Range",
        text: "End date cannot be earlier than the start date.",
      });
      return;
    }

    const dateLabel = isStart ? "Production Start Date" : "Production End Date";

    const isPosted = await postedCutoffValidation(
      selectedDate,
      (val) => {
        if (isStart) {
          setStartDate(startDate);
        } else {
          setDate(val);
        }
      },
      dateLabel,
    );

    if (isPosted) return;

    if (isStart) {
      setStartDate(selectedDate);

      if (selectedDate) {
        const reactiveEndDate = new Date(selectedDate);
        reactiveEndDate.setDate(reactiveEndDate.getDate() + 0);
        setDate(reactiveEndDate);
      } else {
        setDate(null);
      }
    } else {
      setDate(selectedDate);
    }
  };

  return (
    <div className="h-100 w-100 bg-white">
      {authrztn.includes("Productions-Add") ? (
        <>
          <div className="w-100 p-2 d-flex flex-row justify-content-between">
            <div className="d-flex flex-column title-custom">
              <span className="fs-3">
                <Link to="/inventory/productions" className="text-dark me-2">
                  <i class="fa-solid fa-arrow-left"></i>
                </Link>
                PRODUCTION FORM
              </span>
            </div>
          </div>

          <Form noValidate validated={validated} onSubmit={add}>
            <div className="container-fluid mt-3">
              <div className="row">
                <div className="col-sm mb-2">
                  <span>Production ID</span>
                  <input
                    type="text"
                    name=""
                    id=""
                    className="form-control"
                    readOnly
                    value={production_id}
                  />
                </div>
                <div className="col-sm mb-2">
                  <span>Start Date</span>
                  <CustomDatePicker
                    label={"Production Start Date"}
                    selected={startDate ? new Date(startDate) : ""}
                    handleDateChange={(selectedDate) =>
                      handleDateRangeChange(selectedDate, "start")
                    }
                    CustomInput={CustomInput}
                    isRequired={true}
                    validated={validated}
                    dateAndTime={true}
                  />
                </div>
                <div className="col-sm mb-2">
                  <span>End Date</span>
                  <CustomDatePicker
                    label={"Production End Date"}
                    selected={date ? new Date(date) : ""}
                    handleDateChange={(selectedDate) =>
                      handleDateRangeChange(selectedDate, "end")
                    }
                    CustomInput={CustomInput}
                    isRequired={true}
                    validated={validated}
                    dateAndTime={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm mb-2">
                  <span>Shift Schedule</span>
                  <Form.Select
                    required
                    value={shift}
                    onChange={(e) => setShift(e.target.value)}
                    ref={(el) => (shiftWarehouseRef.current[0] = el)}>
                    <option selected disabled value="">
                      Select Shift
                    </option>
                    <option value={"Day Shift"}>Day Shift</option>
                    <option value={"Night Shift"}>Night Shift</option>
                  </Form.Select>
                </div>
                <div className="col-sm mb-2">
                  <span>Machine</span>
                  <Form.Select
                    value={machine}
                    onChange={(e) => setMachine(e.target.value)}>
                    <option selected disabled value="">
                      Select Machine
                    </option>
                    <option value={"Machine 1"}>Machine 1</option>
                    <option value={"Machine 2"}>Machine 2</option>
                    <option value={"Machine 3"}>Machine 3</option>
                  </Form.Select>
                </div>
                <div className="col-sm">
                  <span>Warehouse</span>
                  <Form.Select
                    required
                    value={selectedWarehouse}
                    onChange={(e) => {
                      fetchStockConsumables(e.target.value);
                      fetchStockRaw(e.target.value);
                      // fetchStockFinish(e.target.value);
                      setSelectedWarehouse(e.target.value);
                      setRaws([
                        {
                          stock_id: "",
                          vendor_id: "Any",
                          prod_id: "",
                          prod_code: "",
                          prod_name: "",
                          prod_uom: "",
                          current_stock: "",
                          prod_price: "",
                          weightIn: 0,
                          cost: "",
                        },
                      ]);
                      // setFinishedProductRows([
                      //   {
                      //     prod_id: "",
                      //     prod_code: "",
                      //     prod_name: "",
                      //     prod_uom: "",
                      //     produce: 0,
                      //     current_stock: 0,
                      //     costing: 0,
                      //     unit_price: 0,
                      //   },
                      // ]);
                    }}
                    ref={(el) => (shiftWarehouseRef.current[1] = el)}>
                    <option disabled value="">
                      Select Warehouse
                    </option>
                    {fetchWarehouse.map((data) => (
                      <option id={data.warehouse_id} value={data.warehouse_id}>
                        {data.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>

              <div className="row">
                <div className="col-sm">
                  <span>Product Description</span>
                  <input
                    type="text"
                    name=""
                    id=""
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    className="form-control"
                    placeholder="Enter Description"
                  />
                </div>
              </div>

              <div className="row gap-2 mt-3 mb-4">
                <div className="col-sm">
                  <TotalCard
                    totalLabel={"Consumables Total"}
                    totalQuantity={consumablesTotalWeight}
                    totalCosting={consumablesTotalCosting}
                  />
                </div>

                <div className="col-sm">
                  <TotalCard
                    totalLabel={"Materials Total"}
                    totalQuantity={materialsTotalWeight}
                    totalCosting={materialsTotalCosting}
                  />
                </div>

                <div className="col-sm">
                  <TotalCard
                    totalLabel={"Finished Product Total"}
                    totalQuantity={finishedTotalWeight}
                    totalCosting={finishedTotalCosting}
                  />
                </div>
              </div>

              <div
                className="mt-1 production-form-container"
                ref={containerRef}>
                {/* Consumables Table */}
                <ProductionConsumableCreateTable {...consumableTableProps} />

                {/* Materials Table */}
                <ProductionMaterialsCreateTable {...materialsTableProps} />

                {/* Finished Product Table */}
                <ProductionFinishedCreateTable {...finishedTableProps} />
              </div>
            </div>
            <div className="w-100 d-flex justify-content-end my-5 p-1">
              <button
                className="btn btn-success btn-sm"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  "Save Production"
                )}
              </button>
            </div>
          </Form>
        </>
      ) : (
        <div className="no-access">
          <img src={NoAccess} alt="NoAccess" className="no-access-img" />
          <h3>You don't have access to this function.</h3>
        </div>
      )}
    </div>
  );
};

export default NewProductionCreate;
